import React, { useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  Button,
  Card,
  Typography,
  Divider,
  Row,
  Col,
  Avatar,
  Drawer,
} from "antd";
import { PlusOutlined, DeleteFilled } from "@ant-design/icons";

//
import log from "../../utils/log";
import c from "../../utils/common";
import moment from "moment-timezone";
import dayjs from "dayjs";
import metaData from "../../data/metaData";
import _ from "lodash";
import { style } from "../../css/css";
import { useTranslation } from "react-i18next";

//
import useShopStore from "../../states/useShop";

//
import ProductProfileDisplay from "../ProductProfileDisplay";

const { Title, Text, Paragraph } = Typography;

const RequestDetailView = ({ state = {} }) => {
  const { data, form, onChange } = state;

  return (
    <Row justify="space-evenly" style={{ width: "100%", margin: "1rem 0 5rem 0" }}>
      <Col span={18}>
        <ProductProfileDisplay
          state={{
            data: data?.info?.product,
            form: form,
            onChange: onChange,
          }}
        />
      </Col>
    </Row>
  );
};


export default RequestDetailView;
